import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _class, _descriptor, _class2;
import autobind from 'autobind-decorator';
import { computed, observable, action } from 'mobx';
export class EventInfo {
  constructor(event, status, failureReason) {
    this.event = event;
    this.status = status;
    this.failureReason = failureReason;
  }
}
export let EventInfoStore = (_class = (_class2 = class EventInfoStore {
  constructor() {
    _initializerDefineProperty(this, "eventInfosById", _descriptor, this);
  }
  updateEventStatus(event, status, failureReason) {
    this.eventInfosById.set(event.eventId, new EventInfo(event, status, failureReason));
    if (this.eventInfosById.size > EventInfoStore.MAX_EVENT_SHOWN) {
      // remove the oldest event
      const toRemove = this.eventInfos[0];
      this.eventInfosById.delete(toRemove.event.eventId);
    }
  }
  clearEvents() {
    this.eventInfosById.clear();
  }
  get eventInfos() {
    return Array.from(this.eventInfosById.values());
  }
}, _class2.MAX_EVENT_SHOWN = 100, _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "eventInfosById", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateEventStatus", [autobind, action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEventStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearEvents", [autobind, action], Object.getOwnPropertyDescriptor(_class.prototype, "clearEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eventInfos", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eventInfos"), _class.prototype)), _class);
//# sourceMappingURL=event-info.mobx-model.js.map